export default {
    currentWorkspaceOrganizationMemberUuid: 'ba5b9284-f708-379d-8cbd-21a07300f84a',
    currentWorkspaceChannels: null,
    areChannelsLoaded: false,
    currentWorkspace: null,
    currentProjectOrganizationMember: null,
    currentProjectStages: null,
    workspace: {
        uuid: '',
        name: '',
        description: '',
        workspaceType: '',
        stages: [],
        customStages: {
            plan: {
                members: [
                    {
                        id: 1,
                        fullName: 'Dustin Gray (you)',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/178/419/741/computer-icons-avatar-login-user-avatar.jpg',
                        role: 'Buyer',
                        phone: '555-123-4444',
                        email: 'jack.gray@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 2,
                        fullName: 'Lyssa Gray',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/555/703/598/computer-icons-avatar-woman-user-avatar.jpg',
                        role: 'Buyer',
                        phone: '225-143-4447',
                        email: 'lyssa.gray@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 3,
                        fullName: 'Sally Ames',
                        avatar: null,
                        role: 'Real Estate Agent',
                        phone: '555-123-9987',
                        email: 'sally.ames@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 4,
                        fullName: 'Shawn Arnold',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/178/419/741/computer-icons-avatar-login-user-avatar.jpg',
                        role: 'Attorney',
                        phone: '525-666-4567',
                        email: 'shawn.arnold@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 5,
                        fullName: 'Tanya Ernst',
                        avatar: null,
                        role: 'Title & Escrow',
                        phone: '535-123-6789',
                        email: 'tanya.ernst@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 6,
                        fullName: 'Shawn Arnold',
                        avatar: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:' +
                            'ANd9GcQLfyYmzhHxQVG0sSfcciHd_lV2Cy-75sgqPXYrCx9-jZn3Udnl5A&s',
                        role: 'Attorney',
                        phone: '25-347-4777',
                        email: 'shawn.arnold@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 7,
                        fullName: 'Tanya Ernst',
                        avatar: null,
                        role: 'Title & Escrow',
                        phone: '555-123-4567',
                        email: 'tanya.ernst@gmail.com',
                        timezone: '5:00 PM local time',

                    },
                ],
                membersToAdd: [
                    {
                        id: 1,
                        role: 'Home Inspector',
                    },
                    {
                        id: 2,
                        role: 'Mortgage Lender',
                    },
                    {
                        id: 3,
                        role: 'Insurance Agent',
                    },
                    {
                        id: 4,
                        role: 'Officer',
                    },
                ],
                resources: [],
                files: [
                    {
                        id: 1,
                        name: 'test.doc',
                        title: 'Austin Brokerage Co. Buyer\'s Agency Contrsdgsadgsagd',
                        type: 'pdf',
                        href: '/1',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                    {
                        id: 2,
                        name: 'test.doc',
                        title: '4305 Allston Ln. HOA bylaws',
                        type: 'powerpoint',
                        href: '/2',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                    {
                        id: 3,
                        name: 'test.doc',
                        title: '1291 Sunnyside Ave. Seller\'s Disclosures',
                        type: 'word',
                        href: '/3',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                ],
                events: [
                    {
                        id: 1,
                        type: 'memento',
                        title: 'Showing: 4305 Allston Ln.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 1,
                    },
                    {
                        id: 2,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 2,
                    },
                    {
                        id: 3,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-12 13:00',
                        duration: 2,
                    },
                    {
                        id: 4,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 14:00',
                        duration: 3,
                    },
                    {
                        id: 5,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 18:00',
                        duration: 2,
                    },
                ],
                tasks: [
                    {
                        id: 1,
                        title: 'Learn about mortgages',
                        tags: ['1234 Hudson. Av', 'test tag'],
                        starred: false,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga' +
                            ' maiores mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne1',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        deadline: '2019-11-19',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand ' +
                                    'how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 2,
                        tags: ['1234 Hudson. Av'],
                        title: 'Get prepared (get docs, be ready to answer questions, and everything else)',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-18',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand how much' +
                                    ' you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 4,
                        tags: ['1234 Hudson. Av'],
                        starred: true,
                        title: 'Contact broker',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-15',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand' +
                                    ' how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 3,
                        tags: ['1234 Hudson. Av'],
                        title: 'Compare lenders',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-20',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand how' +
                                    ' much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                ],
            },
            search: {
                resources: [
                    {
                        title: 'Search 101',
                        description: 'Search, save, discuss, and tour homes for sale.',
                        icon: '/static/search_101.png',
                        route: {name: 'stage', params: {stage: 'search'}},
                    },
                    {
                        title: 'Search Properties',
                        description: 'Search, save, discuss, and tour homes for sale.',
                        icon: '/static/search_properties.png',
                        route: {name: 'stage.app.search-properties'},
                    },
                    {
                        title: 'Manage Tours',
                        description: 'Schedule tours and keep track of what you saw.',
                        icon: '/static/manage_tours.png',
                        route: {name: 'stage', params: {stage: 'search'}},
                    },
                    {
                        title: 'Compare Grid',
                        description: 'Learn how to execute a home search using tips & tricks from industry pros.',
                        icon: '/static/compare_grid.png',
                        route: {name: 'stage', params: {stage: 'search'}},
                    },
                ],
                events: [
                    {
                        id: 1,
                        type: 'memento',
                        title: 'Showing: 4305 Allston Ln.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 1,
                    },
                    {
                        id: 2,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 2,
                    },
                    {
                        id: 3,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-12 13:00',
                        duration: 2,
                    },
                    {
                        id: 4,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 14:00',
                        duration: 3,
                    },
                    {
                        id: 5,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 18:00',
                        duration: 2,
                    },
                ],
                tasks: [
                    {
                        id: 1,
                        title: 'Learn about mortgages',
                        tags: ['1234 Hudson. Av', 'test tag'],
                        starred: false,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            '  dignissimos dolore doloribus ea eaque fuga' +
                            ' maiores mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne1',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        deadline: '2019-11-19',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand' +
                                    ' how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 2,
                        tags: ['1234 Hudson. Av'],
                        title: 'Get prepared (get docs, be ready to answer questions, and everything else)',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-18',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand ' +
                                    'how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 4,
                        tags: ['1234 Hudson. Av'],
                        starred: true,
                        title: 'Contact broker',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-15',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand' +
                                    ' how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 3,
                        tags: ['1234 Hudson. Av'],
                        title: 'Compare lenders',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-20',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to' +
                                    ' understand how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/' +
                                    'drverner1602/drverner160200043/' +
                                    '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                ],
            },
            inspect: {
                members: [
                    {
                        id: 1,
                        fullName: 'Dustin Gray (you)',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/178/419/741/computer-icons-avatar-login-user-avatar.jpg',
                        role: 'Buyer',
                        phone: '555-123-4444',
                        email: 'jack.gray@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 2,
                        fullName: 'Lyssa Gray',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/555/703/598/computer-icons-avatar-woman-user-avatar.jpg',
                        role: 'Buyer',
                        phone: '225-143-4447',
                        email: 'lyssa.gray@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 3,
                        fullName: 'Sally Ames',
                        avatar: null,
                        role: 'Real Estate Agent',
                        phone: '555-123-9987',
                        email: 'sally.ames@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 4,
                        fullName: 'Shawn Arnold',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/178/419/741/computer-icons-avatar-login-user-avatar.jpg',
                        role: 'Attorney',
                        phone: '525-666-4567',
                        email: 'shawn.arnold@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 5,
                        fullName: 'Tanya Ernst',
                        avatar: null,
                        role: 'Title & Escrow',
                        phone: '535-123-6789',
                        email: 'tanya.ernst@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 6,
                        fullName: 'Shawn Arnold',
                        avatar: 'https://encrypted-tbn0.gstatic.com/' +
                            'images?q=tbn:ANd9GcQLfyYmzhHxQVG0sSfcciHd_lV2Cy-75sgqPXYrCx9-jZn3Udnl5A&s',
                        role: 'Attorney',
                        phone: '25-347-4777',
                        email: 'shawn.arnold@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 7,
                        fullName: 'Tanya Ernst',
                        avatar: null,
                        role: 'Title & Escrow',
                        phone: '555-123-4567',
                        email: 'tanya.ernst@gmail.com',
                        timezone: '5:00 PM local time',

                    },
                ],
                membersToAdd: [
                    {
                        id: 1,
                        role: 'Home Inspector',
                    },
                    {
                        id: 2,
                        role: 'Mortgage Lender',
                    },
                    {
                        id: 3,
                        role: 'Insurance Agent',
                    },
                    {
                        id: 4,
                        role: 'Officer',
                    },
                ],
                resources: [],
                files: [
                    {
                        id: 1,
                        name: 'test.doc',
                        title: 'Austin Brokerage Co. Buyer\'s Agency Contrsdgsadgsagd',
                        type: 'pdf',
                        href: '/1',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                    {
                        id: 2,
                        name: 'test.doc',
                        title: '4305 Allston Ln. HOA bylaws',
                        type: 'powerpoint',
                        href: '/2',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                    {
                        id: 3,
                        name: 'test.doc',
                        title: '1291 Sunnyside Ave. Seller\'s Disclosures',
                        type: 'word',
                        href: '/3',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                ],
                events: [
                    {
                        id: 1,
                        type: 'memento',
                        title: 'Showing: 4305 Allston Ln.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 1,
                    },
                    {
                        id: 2,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 2,
                    },
                    {
                        id: 3,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-12 13:00',
                        duration: 2,
                    },
                    {
                        id: 4,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 14:00',
                        duration: 3,
                    },
                    {
                        id: 5,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 18:00',
                        duration: 2,
                    },
                ],
                tasks: [
                    {
                        id: 1,
                        title: 'Learn about mortgages',
                        tags: ['1234 Hudson. Av', 'test tag'],
                        starred: false,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne1',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        deadline: '2019-11-19',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand' +
                                    ' how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 2,
                        tags: ['1234 Hudson. Av'],
                        title: 'Get prepared (get docs, be ready to answer questions, and everything else)',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-18',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand' +
                                    ' how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 4,
                        tags: ['1234 Hudson. Av'],
                        starred: true,
                        title: 'Contact broker',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-15',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand ' +
                                    'how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 3,
                        tags: ['1234 Hudson. Av'],
                        title: 'Compare lenders',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-20',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand ' +
                                    'how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                ],
            },
            close: {
                members: [
                    {
                        id: 1,
                        fullName: 'Dustin Gray (you)',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/178/419/741/computer-icons-avatar-login-user-avatar.jpg',
                        role: 'Buyer',
                        phone: '555-123-4444',
                        email: 'jack.gray@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 2,
                        fullName: 'Lyssa Gray',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/555/703/598/computer-icons-avatar-woman-user-avatar.jpg',
                        role: 'Buyer',
                        phone: '225-143-4447',
                        email: 'lyssa.gray@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 3,
                        fullName: 'Sally Ames',
                        avatar: null,
                        role: 'Real Estate Agent',
                        phone: '555-123-9987',
                        email: 'sally.ames@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 4,
                        fullName: 'Shawn Arnold',
                        // eslint-disable-next-line max-len
                        avatar: 'https://i7.pngguru.com/preview/178/419/741/computer-icons-avatar-login-user-avatar.jpg',
                        role: 'Attorney',
                        phone: '525-666-4567',
                        email: 'shawn.arnold@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 5,
                        fullName: 'Tanya Ernst',
                        avatar: null,
                        role: 'Title & Escrow',
                        phone: '535-123-6789',
                        email: 'tanya.ernst@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 6,
                        fullName: 'Shawn Arnold',
                        avatar: 'https://encrypted-tbn0.gstatic.com/' +
                            'images?q=tbn:ANd9GcQLfyYmzhHxQVG0sSfcciHd_lV2Cy-75sgqPXYrCx9-jZn3Udnl5A&s',
                        role: 'Attorney',
                        phone: '25-347-4777',
                        email: 'shawn.arnold@gmail.com',
                        timezone: '5:00 PM local time',
                    },
                    {
                        id: 7,
                        fullName: 'Tanya Ernst',
                        avatar: null,
                        role: 'Title & Escrow',
                        phone: '555-123-4567',
                        email: 'tanya.ernst@gmail.com',
                        timezone: '5:00 PM local time',

                    },
                ],
                membersToAdd: [
                    {
                        id: 1,
                        role: 'Home Inspector',
                    },
                    {
                        id: 2,
                        role: 'Mortgage Lender',
                    },
                    {
                        id: 3,
                        role: 'Insurance Agent',
                    },
                    {
                        id: 4,
                        role: 'Officer',
                    },
                ],
                resources: [],
                files: [
                    {
                        id: 1,
                        name: 'test.doc',
                        title: 'Austin Brokerage Co. Buyer\'s Agency Contrsdgsadgsagd',
                        type: 'pdf',
                        href: '/1',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                    {
                        id: 2,
                        name: 'test.doc',
                        title: '4305 Allston Ln. HOA bylaws',
                        type: 'powerpoint',
                        href: '/2',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                    {
                        id: 3,
                        name: 'test.doc',
                        title: '1291 Sunnyside Ave. Seller\'s Disclosures',
                        type: 'word',
                        href: '/3',
                        creationDate: 'Jan 15 10:21 AM',
                        member: {
                            name: 'Shawn Arnold',
                            // eslint-disable-next-line max-len
                            avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png',
                        },
                    },
                ],
                events: [
                    {
                        id: 1,
                        type: 'memento',
                        title: 'Showing: 4305 Allston Ln.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 1,
                    },
                    {
                        id: 2,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-29 12:00',
                        duration: 2,
                    },
                    {
                        id: 3,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-12 13:00',
                        duration: 2,
                    },
                    {
                        id: 4,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 14:00',
                        duration: 3,
                    },
                    {
                        id: 5,
                        type: 'memento',
                        title: 'Showing: 1291 Sunnyside Ave.',
                        locationAddress: '1234 Bennedict Ln, Austing TX 78746',
                        members: [
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        date: '2019-11-30 18:00',
                        duration: 2,
                    },
                ],
                tasks: [
                    {
                        id: 1,
                        title: 'Learn about mortgages',
                        tags: ['1234 Hudson. Av', 'test tag'],
                        starred: false,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne1',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                        ],
                        deadline: '2019-11-19',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand' +
                                    ' how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 2,
                        tags: ['1234 Hudson. Av'],
                        title: 'Get prepared (get docs, be ready to answer questions, and everything else)',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-18',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand' +
                                    ' how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/' +
                                    'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 4,
                        tags: ['1234 Hudson. Av'],
                        starred: true,
                        title: 'Contact broker',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-15',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand ' +
                                    'how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/drverner160200043/' +
                                    '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                    {
                        id: 3,
                        tags: ['1234 Hudson. Av'],
                        title: 'Compare lenders',
                        starred: true,
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
                            ' Amet autem corporis, culpa\n' +
                            ' dignissimos dolore doloribus ea eaque fuga maiores' +
                            ' mollitia non nostrum obcaecati officia\n' +
                            ' quaerat quisquam quo quos, soluta ullam?',
                        users: [
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'Sanya Thorne',
                                image: 'https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg',
                            },
                            {
                                name: 'John Doe',
                            },
                        ],
                        deadline: '2019-11-20',
                        dueHour: '12:00',
                        reminderType: 'Email',
                        reminderDate: '2019-11-19',
                        reminderHour: '11:00',
                        links: [
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'http://catmomsneedhomestoo.com',
                                href: 'http://catmomsneedhomestoo.com',
                            },
                            {
                                text: 'How to fill an application form',
                                href: '#',
                            },
                        ],
                        articles: [
                            {
                                id: 2,
                                title: 'Refinance calculator - Should you refinance your mortgage?',
                                description: 'Try this refinance caculator to understand ' +
                                    'how much you could save if you refinance your mortgage',
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'calculator',
                                images: [
                                    'https://s3.envato.com/files/245551182/T13A8556.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                            {
                                id: 3,
                                title: `How to make homebuying easier when you're self-employed`,
                                description: `Being a self-employed borrower can make homebuying more difficult.`,
                                author: 'The North Face',
                                date: 'Feb 12, 2019',
                                type: 'article',
                                images: [
                                    'https://previews.123rf.com/images/drverner/drverner1602/drverner160200043/' +
                                    '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                                ],
                                tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                            },
                        ],
                    },
                ],
            },
        },
    },
    defaultMlsAbbreviation: null,
    defaultSwNeMapLocationCoordinates: null,
    buyFilter: null,
};
